import React, { useEffect, useState } from "react";
import axios from "axios";

const CenterReportMapping = () => {
  const [centers, setCenters] = useState([]);
  const [reports, ] = useState([
    "Agent Sales Report",
    "Verif Sales Report",
   "Customer Data",
    "Verif Product Report",
    "Center Product Report",
    "Agent Wise Center Sales Performance Report",
    "Verifier Wise Center Sales Performance Report",
    "Leader Performance Report",
    "Agent Wise Leader Performance Report",
    "Verifier Wise Leader Performance Report"
  ]);

  const [form, setForm] = useState({
    center: "",
    role: "",
    isActive: "true",
  });

  const [selectedReports, setSelectedReports] = useState([]);
  const [mappingExists, setMappingExists] = useState(false);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  // ✅ Fetch centers on mount
  useEffect(() => {
    const fetchCenters = async () => {
      try {
        const res = await axios.get("https://crm-server-htk6.vercel.app/api/centers");
        setCenters(res.data || []);
      } catch (err) {
        console.error("❌ Error fetching centers:", err);
      }
    };
    fetchCenters();
  }, []);

  // ✅ Fetch existing mapping when center & role change
  useEffect(() => {
    if (!form.center || !form.role) return;
    setLoading(true);
    axios
      .get(
        `https://crm-server-htk6.vercel.app/api/report-mapping?center=${encodeURIComponent(
          form.center
        )}&role=${encodeURIComponent(form.role)}`
      )
      .then((res) => {
        if (res.data) {
          setMappingExists(true);
          setSelectedReports(res.data.reports || []);
          setForm((prev) => ({
            ...prev,
            isActive: res.data.isActive ? "true" : "false",
          }));
        } else {
          setMappingExists(false);
          setSelectedReports([]);
          setForm((prev) => ({ ...prev, isActive: "true" }));
        }
      })
      .catch((err) => console.error("❌ Error fetching mapping:", err))
      .finally(() => setLoading(false));
  }, [form.center, form.role]);

  // ✅ Toggle report checkbox
  const toggleReport = (reportName) => {
    setSelectedReports((prev) =>
      prev.includes(reportName)
        ? prev.filter((r) => r !== reportName)
        : [...prev, reportName]
    );
  };

  // ✅ Save or update mapping
  const handleSave = async () => {
    if (!form.center || !form.role) {
      return alert("Please select Center and Role");
    }
    const payload = {
      center: form.center,
      role: form.role,
      isActive: form.isActive === "true",
      reports: selectedReports,
    };

    try {
      setSaving(true);
      await axios.post("https://crm-server-htk6.vercel.app/api/report-mapping", payload);
      alert(mappingExists ? "✅ Mapping updated" : "✅ Mapping created");
      setMappingExists(true);
    } catch (err) {
      console.error("❌ Error saving mapping:", err);
      alert("⚠️ Failed to save mapping");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page">
      <h2>Center - Role Report Mapping</h2>

      {/* Filter / Form Section */}
      <div className="form-container">
        <div className="form-row">
          {/* Center Dropdown */}
          <select
            value={form.center}
            onChange={(e) => setForm({ ...form, center: e.target.value })}
          >
            <option value="">Select Center</option>
            {centers.map((c) => (
              <option key={c._id} value={c.centerName}>
                {c.centerName}
              </option>
            ))}
          </select>

          {/* Role Dropdown */}
          <select
            value={form.role}
            onChange={(e) => setForm({ ...form, role: e.target.value })}
          >
            <option value="">Select Role</option>
            <option value="SuperAdmin">Super Admin</option>
            <option value="Admin">Admin</option>
            <option value="Team Leader">Team Leader</option>
            <option value="Manager">Manager</option>
            <option value="Assessor">Assessor</option>
            <option value="QA">QA</option>
            <option value="QA Manager">QA Manager</option>
            <option value="MIS">MIS</option>
            <option value="MIS Manager">MIS Manager</option>
            <option value="Agent">Agent</option>
            <option value="Verifier">Verifier</option>
          </select>

          {/* Active Dropdown */}
          <select
            value={form.isActive}
            onChange={(e) => setForm({ ...form, isActive: e.target.value })}
          >
            <option value="true">Active</option>
            <option value="false">Inactive</option>
          </select>
        </div>

        <button className="save-btn" onClick={handleSave} disabled={saving}>
          {saving ? "Saving..." : mappingExists ? "Update" : "Save"}
        </button>
      </div>

      {/* Reports Checkbox List */}
      <div className="rules-block">
        <h3>Select Reports</h3>

        {loading ? (
          <p>Loading mapping...</p>
        ) : (
          <div className="checkbox-group">
            {reports.map((r) => (
              <label key={r}>
                <input
                  type="checkbox"
                  checked={selectedReports.includes(r)}
                  onChange={() => toggleReport(r)}
                />
                {r}
              </label>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CenterReportMapping;
